import { useTranslation } from 'react-i18next';

const features = [
  {
    icon: 'ri-refresh-line',
    titleKey: 'features.atualizacao.title',
    descKey: 'features.atualizacao.desc',
  },
  {
    icon: 'ri-check-double-line',
    titleKey: 'features.precos.title',
    descKey: 'features.precos.desc',
  },
  {
    icon: 'ri-global-line',
    titleKey: 'features.envio.title',
    descKey: 'features.envio.desc',
  },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-400 font-semibold mb-4">
            {t('features.label')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-foreground-950 leading-tight max-w-3xl">
            {t('features.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/40"
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center mb-5">
                <i className={`${feat.icon} w-6 h-6 flex items-center justify-center text-foreground-700`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                {t(feat.titleKey)}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {t(feat.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}